export var UserSsoState;
(function (UserSsoState) {
    UserSsoState["UNREGISTERED"] = "unregistered";
    UserSsoState["REGISTERED"] = "registered";
    UserSsoState["NEEDS_MERGE"] = "needs_merge";
})(UserSsoState || (UserSsoState = {}));
